<template>
  <div class="container category-page">
    <block-breadcrumbs />
    <banners-slot
      class="bottom-offset"
      slot-name="transparency_subcategory"
    />
    <page-head
      :title="SEO.head || CATEGORY_NAME"
      :info="subtitle"
    />
    <div class="body">
      <side-nav />
      <div class="content">
        <filters />
        <template v-if="PRODUCTS.length">
          <products-list />
        </template>
        <page-info
          v-else
          title="Товары не найдены"
        >
          <no-delivery-warning />
        </page-info>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { catalogGtmEvents } from '@/gtm/catalog-gtm-events';
import { PRICE_FILTER_ID } from '@/store/consts';

/* Components */
import blockBreadcrumbs from '../components/breadcrumbs/breadcrumbs';
import ProductsList from '../components/catalog/products-list.vue';
import SideNav from '../components/catalog/side-nav.vue';
import Filters from '../components/filters/filters.vue';
import PageHead from '../components/common/page-head.vue';
import PageInfo from '../components/common/page-info.vue';
import BannersSlot from '@/components/banners-slot/banners-slot.vue';
import NoDeliveryWarning from '@/components/catalog/no-delivery-warning.vue';

export default {
  name: 'subcategory',

  metaInfo() {
    const meta = [
      {
        name: 'description',
        content: this.SEO.description || this.CATEGORY_NAME,
        vmid: 'description',
      }
    ];

    this.SEO.keywords && meta.push({
      name: 'keywords',
      content: this.SEO.keywords,
      vmid: 'keywords',
    });

    return {
      title: this.SEO.title || this.CATEGORY_NAME,
      meta
    };
  },

  components: {
    NoDeliveryWarning,
    blockBreadcrumbs,
    PageHead,
    ProductsList,
    SideNav,
    PageInfo,
    Filters,
    BannersSlot,
  },

  computed: {
    ...mapGetters({
      PRODUCTS: 'category/products',
      PRODUCTS_COUNT: 'category/productsCount',
      CATEGORY_NAME: 'category/categoryName',
      FILTER_URL_PARAM: 'category/filterURLParam',
      SEO: 'category/seo',
      CITY: 'user/city',
    }),
    subtitle() {
      return `
        ${this.PRODUCTS_COUNT}
        ${this.$options.filters.decl(this.PRODUCTS_COUNT, 'товар', ['', 'а', 'ов'])}
      `;
    },
  },

  watch: {
    FILTER_URL_PARAM(val) {
      const newUrl = new URL(window.location);
      newUrl.search = val;

      history.pushState(null, '', newUrl.toString());
    },
  },

  mounted() {
    // Google Tag Manager event
    catalogGtmEvents.viewCatalogPage({
      cityName: this.CITY?.name,
      categoryId: this.$route.path,
      products: this.PRODUCTS?.slice(0, 3),
    });
  },

  methods: {
    ...mapActions({
      applyCategoryFilter: 'category/applyCategoryFilter'
    }),
  },

  serverPrefetch () {
    const query = this.$route.query;
    const emptyExcluded = Object.entries(query).filter(([id, value]) => !!value);
    const { sort, ...filters} = Object.fromEntries(emptyExcluded);
    const filterData = Object.entries(filters)
      .map(([id, value]) => {
        if (id === PRICE_FILTER_ID) {
          const [from, to] = value.split(',');

          return {
            id,
            value: [{from, to}],
          };
        }

        return {
          id,
          value: value.split(',').map(i => ({ value: i }))
        };
      });

    return this.applyCategoryFilter({ filterData, sort });
  },
};
</script>

<style lang="scss">
.category-page {
  margin-bottom: 30px;
  .body {
    display: flex;
    .content {
      padding-top: 24px;
      flex: 1;
      max-width: 100%;
      overflow: hidden;
    }
  }
}
</style>
